import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import TelegramIcon from '@material-ui/icons/Telegram';
import TwitterIcon from '@material-ui/icons/Twitter';
// import MediumIcon from '@material-ui/icons/MediumOutlined';


import './footer.css'
// images
import logoimg from '../../img/logo.png'

const Footerhow = (props) => {
  return (
    <div className="pcc---headerMenu pcc---gray_background pcc---footer mt-5 d-block">
        <Container maxWidth="lg">
        <Grid
            container
            direction="row"
            justify="flex-start"
            xs={11}
            className="bg-dark mx-auto"
            >
                {/* <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    xs={12}
                    sm={6}
                    className="mt-4 py-5 px-4"
                    >
                       <h2 className="text-left text-light">It's all about the voice of the people <br />- The community.</h2> 
                </Grid>
                <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    xs={12}
                    sm={6}
                    className="mt-4 py-5 px-4"
                    >
                        <form className="Footer---form">
                            <div>
                                <input type="email" className="email" placeholder="Enter your email address" />
                                <input type="submit" className="submit" />
                                <p className="text-light mt-2 text-left">SUBSCRIBE TO OUR NEWSLETTER</p>
                            </div> 
                        </form> 
                </Grid> */}
            </Grid>
        </Container>
        <Container 
            maxWidth="xl"
            className="py-5"
        >
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Grid container xs={12} sm={2}>
            <a href="#">
                <img src={logoimg} />
            </a>
            </Grid>
            <Grid 
            container 
            direction="row"
            justify="center"
            xs={8}
            className="d-none d-sm-flex"
            >
              <ul>
                <li>
                  <a href='/launch'>Launch</a>
                </li>
                <li>
                  <a href='/coin-burn'>Coin Burn</a>
                </li>
                <li>
                  <a href='/#road-map'>Road Map</a>
                </li>
                <li>
                  <a href='/white-paper'>White Paper</a>
                </li>
                <li>
                  <a href='/wall-of-fame'>Wall of Fame</a>
                </li>
              </ul>
            </Grid>
            <Grid 
            container 
            xs={12} 
            sm={2}
            justify="center"
            >
              <a href='https://t.me/pCatCore' target="_blank" className="pcc---footer-menu-icons"><TelegramIcon /></a>
              <a href='https://twitter.com/pussyCatcore' target="_blank" className="pcc---footer-menu-icons"><TwitterIcon /></a>
              {/* <a href='https://medium.com/@vinayk217782/2b9d93418b51' target="_blank" className="pcc---footer-menu-icons"><MediumIcon /></a> */}
            </Grid>
        </Grid>
        </Container>
    </div>
  );
}

export default Footerhow;
